import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';



const InteractiveMap = ({ partnerships, onPartnershipClick }) => {
  const [hoveredPartnership, setHoveredPartnership] = useState(null);

  const mapRegions = [
    { id: 'uk', name: 'United Kingdom', x: '48%', y: '25%', count: 12 },
    { id: 'spain', name: 'Spain', x: '45%', y: '45%', count: 8 },
    { id: 'italy', name: 'Italy', x: '52%', y: '48%', count: 6 },
    { id: 'germany', name: 'Germany', x: '52%', y: '30%', count: 7 },
    { id: 'france', name: 'France', x: '48%', y: '38%', count: 5 }
  ];

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 border border-border">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="MapPin" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground font-headline">
              Global Partnership Network
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              Interactive map of our European football partnerships
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="ZoomIn"
            iconPosition="left"
            className="hidden md:flex"
          >
            Zoom In
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="ZoomOut"
            iconPosition="left"
            className="hidden md:flex"
          >
            Zoom Out
          </Button>
        </div>
      </div>
      <div className="relative w-full bg-muted rounded-lg overflow-hidden" style={{ minHeight: '500px' }}>
        <iframe
          width="100%"
          height="500"
          loading="lazy"
          title="European Partnership Network Map"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=51.5074,-0.1278&z=4&output=embed"
          className="w-full h-full"
        />

        {mapRegions?.map((region) => (
          <div
            key={region?.id}
            className="absolute transform -translate-x-1/2 -translate-y-1/2 cursor-pointer group"
            style={{ left: region?.x, top: region?.y }}
            onMouseEnter={() => setHoveredPartnership(region?.id)}
            onMouseLeave={() => setHoveredPartnership(null)}
          >
            <div className="relative">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-primary rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300 animate-pulse">
                <span className="text-xs md:text-sm font-bold text-primary-foreground">
                  {region?.count}
                </span>
              </div>
              {hoveredPartnership === region?.id && (
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-card border border-border rounded-lg shadow-xl whitespace-nowrap z-10 animate-fade-in">
                  <p className="text-sm font-semibold text-foreground">{region?.name}</p>
                  <p className="text-xs text-muted-foreground">{region?.count} partnerships</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {mapRegions?.map((region) => (
          <button
            key={region?.id}
            onClick={() => onPartnershipClick(region?.id)}
            className="flex items-center gap-2 px-3 py-2 bg-muted hover:bg-muted/80 rounded-lg transition-colors duration-300"
          >
            <div className="w-3 h-3 bg-primary rounded-full" />
            <div className="text-left flex-1 min-w-0">
              <p className="text-xs md:text-sm font-medium text-foreground truncate">
                {region?.name}
              </p>
              <p className="text-xs text-muted-foreground">{region?.count} clubs</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default InteractiveMap;